import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface ILoadingState {
  isScreenLoading: boolean;
  message?: string;
  isReceiveOperationLoading: boolean;
  receiveOperationMessage?: string;
}

const initialState: ILoadingState = {
  isScreenLoading: false,
  isReceiveOperationLoading: false,
};

const loadingSlice = createSlice({
  name: 'loading',
  initialState,
  reducers: {
    setOpenLoading: (state, action: PayloadAction<{ isLoading: boolean }>) => {
      state.isScreenLoading = action.payload.isLoading;
    },
    setMessageLoading: (
      state,
      action: PayloadAction<{
        message?: string;
      }>
    ) => {
      state.message = action.payload.message;
    },
    setReceiveOperationLoading: (state, action: PayloadAction<{ isLoading: boolean }>) => {
      state.isReceiveOperationLoading = action.payload.isLoading;
    },
    setReceiveOperationMessage: (
      state,
      action: PayloadAction<{
        message?: string;
      }>
    ) => {
      state.receiveOperationMessage = action.payload.message;
    },
    clearReceiveOperationLoading: (state) => {
      state.isReceiveOperationLoading = false;
      state.receiveOperationMessage = undefined;
    },
    setInitialStateLoading: (state) => {
      state.isScreenLoading = false;
      state.message = undefined;
      state.isReceiveOperationLoading = false;
      state.receiveOperationMessage = undefined;
    },
  },
});

export const {
  setOpenLoading,
  setMessageLoading,
  setReceiveOperationLoading,
  setReceiveOperationMessage,
  clearReceiveOperationLoading,
  setInitialStateLoading,
} = loadingSlice.actions;

const LoadingReducer = loadingSlice.reducer;

export default LoadingReducer;
